<template>
  <div>
    <nav-breadcrumb :menu="[{label: '异常还款记录'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-row>
          <div class="xzpadd10">
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "FinanceRepaymentExceptionList"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/Finance/FinanceRepaymentExceptionList.vue